export enum ApptTypeEnum {
  ValidValue        = '8EA0B351-EDC8-493A-9FA3-CF899E97E70E',
  Scheduled         = '00000071-0000-0000-0000-000000000001',
  ExternalEmergency = '00000071-0000-0000-0000-000000000002',
  InternalEmergency = '00000071-0000-0000-0000-000000000003',
  VideoConsultation = '00000071-0000-0000-0000-000000000004',
  BlockOut          = '00000071-0000-0000-0000-000000000005',
  BlockIn           = '00000071-0000-0000-0000-000000000006'
}
